module.exports = __webpack_public_path__ + "files/cf1c73aeb2c841d37755b750b2a742f6.png";